/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage } from 'formik';

const component = ({
    field, value, form, isChecked, ...rest
}) => (
    <>
        <input
            {...field}
            {...rest}
            type="radio"
            value={value}
            checked={isChecked}
        />
        <ErrorMessage
            component="div"
            className="text-danger"
            name={field.name}
        />
    </>
);

component.propTypes = {
    field: PropTypes.any.isRequired,
    form: PropTypes.any.isRequired,
};

const FormikRadio = (props) => (
    <Field
        {...props}
        component={component}
    />
);

export default FormikRadio;
